export const serverUrl = "https://mediamarkt.alo-tech.com/api/?"; 